module.exports = __webpack_public_path__ + "img/野柳女王頭.bc96db9d.jpg";